"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _withComponentProp = _interopRequireDefault(require("../../HOC/withComponentProp"));
var _excluded = ["classes", "className", "disabled", "onClick", "role", "theme"];
/*:: import { type Node } from 'react';*/
/*:: import { type ThemeType, type InjectSheetProvidedProps } from '../../style/ThemeTypes';*/
var Component = (0, _withComponentProp.default)('div');
var Style = function Style(theme /*: ThemeType*/) {
  return {
    root: {
      padding: '.75rem 0',
      display: 'flex',
      alignItems: 'flex-start',
      flexDirection: 'row'
    },
    disabled: theme.mixins.disabled
  };
};
/*:: type Props = InjectSheetProvidedProps &
  HTMLDivElement & {
    disabled?: boolean,
    onClick?: (event: SyntheticEvent<HTMLDivElement>) => mixed,
    role?: string
  };*/
var ListItem = function ListItem(_ref /*:: */) {
  var classes = _ref /*:: */.classes,
    className = _ref /*:: */.className,
    disabled = _ref /*:: */.disabled,
    onClick = _ref /*:: */.onClick,
    role = _ref /*:: */.role,
    theme = _ref /*:: */.theme,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return /*#__PURE__*/ /*: Node*/_react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.disabled, disabled), className),
    onClick: onClick,
    role: role || (typeof onClick === 'function' ? 'button' : undefined)
  }, props));
};
ListItem.displayName = 'ListItem';
var _default = exports.default = (0, _injectSheet.default)(Style)(ListItem);
//# sourceMappingURL=ListItem.js.map